import { render, staticRenderFns } from "./removeDialog.vue?vue&type=template&id=070c06bc&"
import script from "./removeDialog.vue?vue&type=script&lang=js&"
export * from "./removeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports